<h3 class="mr-3">Title insurance</h3>
<app-mms-mortgage-warning></app-mms-mortgage-warning>
<div class="flex justify-center mb-10">
	<div class="flex flex-col items-center">
		<div class="flex w-32 h-16">
			<img
				src="/assets/images/integrations/stewart-title-logo.svg"
				alt="Stewart Title Logo"
			/>
		</div>
		<button
			*ngIf="(!status || allowSwitchProviders) && !loading"
			class="text-sm text-green underline cursor-pointer mb-3"
			(click)="selectInsuranceProvider()"
			[testHook]="testHooks.SelectInsuranceProviderSpan"
		>
			Switch provider
		</button>
		<app-title-insurance-toolbar
			[provider]="titleInsurance?.provider"
			[status]="status"
			[orderValid]="orderValid"
			(openModal)="submitFile()"
			(cancelOrder)="cancel()"
		></app-title-insurance-toolbar>
		<app-missing-fields-notif
			*ngIf="
				status && !orderValid && !isCommercial && !isOther && !isMobileHome
			"
			[missing]="missing"
		></app-missing-fields-notif>
	</div>
</div>

<div class="flex gap-2 items-center justify-between mt-1">
	<hr class="w-5/12 mt-2" />
	<p class="text-lg font-bold text-center">Order summary</p>
	<hr class="w-5/12 mt-2" />
</div>

<div
	class="flex items-center justify-center my-1"
	*ngIf="titleInsurance?.onHold"
>
	<atomic-message-bar
		type="warn"
		[shadow]="false"
		[testHook]="testHooks.MessageBar"
		>Your file is currently on hold.</atomic-message-bar
	>
</div>

<div
	*ngIf="status && status !== StewartStatus.NOT_SUBMITTED"
	class="flex gap-2 justify-center items-center mt-3"
>
	<div class="border-r border-grey-veryLight pr-2">
		<p>
			<span class="text-gray">Order number: </span>
			<span class="font-bold"> {{ titleInsurance?.thirdPartyId }} </span>
		</p>
	</div>
	<div
		class="border-r border-grey-veryLight pr-2"
		*ngIf="titleInsurance?.orderedOn"
	>
		<p>
			<span class="text-gray">Order date: </span>
			<span class="font-bold">
				{{ titleInsurance?.orderedOn | date: 'mediumDate' }}
			</span>
		</p>
	</div>
	<div *ngIf="effectiveDate$ | async">
		<p>
			<span class="text-gray">Effective date: </span>
			<span class="font-bold">
				{{ effectiveDate$ | async | date: 'mediumDate' }}
			</span>
		</p>
	</div>
</div>

<div
	*ngIf="status !== StewartStatus.ORDERED"
	class="flex mt-10 justify-center mx-4"
>
	<app-step-progress-nav
		class="stepper"
		[steps]="steps"
		[current]="currentStep"
		[testHook]="testHooks.StepProgressNav"
	></app-step-progress-nav>
</div>

<app-stewart-not-submitted
	*ngIf="
		!status ||
		status === StewartStatus.NOT_SUBMITTED ||
		status === StewartStatus.ORDER_RESUBMIT_REQUIRED
	"
	[missing]="missing"
	[orderValid]="orderValid"
	[canSubmit]="canSubmit"
	[changePropertyButtonText]="changePropertyButtonText"
	[outOfOntario]="outOfOntario"
	[isOther]="isOther"
	[isMobileHome]="isMobileHome"
	[isCommercial]="isCommercial"
	[showPriorityWarning]="showPriorityWarning"
	[status]="status"
></app-stewart-not-submitted>
<app-stewart-flagged
	*ngIf="status === StewartStatus.FLAGGED"
	[matterId]="matterId"
	[thirdPartyId]="thirdPartyId"
	[loginUrl]="loginUrl"
	[status]="status"
></app-stewart-flagged>
<app-stewart-ordered
	*ngIf="status === StewartStatus.ORDERED"
></app-stewart-ordered>
<app-stewart-cancelled
	*ngIf="status === StewartStatus.CANCELLED"
></app-stewart-cancelled>
<app-stewart-declined
	*ngIf="status === StewartStatus.DECLINED"
></app-stewart-declined>
